<script setup>
import { computed, inject, ref } from "vue";
import { __ } from '@/utils';

const { phone, response } = defineProps(['phone', 'response']);

const qrURL = computed(() => {
    return response?.subscribers?.[0]?.sim.qr_url;
});

const { 
    DEFINED_STEPS,
    setStep,
    simIsPorted
} = inject('form');

const htmlTextNewLine = ref(simPdfGuilds.qr_new_line)
const htmlTextPorting = ref(simPdfGuilds.qr_porting)
</script>
<template>
    <div class="qr-section qr-section--alt">
        <div class="step-heading side-spacing mb24">
            <h3 class="mb15"><strong>{{ __('How to set up eSIM') }}</strong></h3>
            <p>{{ __('Please note that this code is linked') }} <strong class="red-text">{{ __('only to the number') }} {{ phone }}</strong></p>
            <span>{{ __('To complete the process, make sure the device is connected to mobile internet/WIFI.') }}</span><br/>
            <span>{{ __('Now scan the QR code.') }}</span><br/>
            <span>{{ __('After scanning, follow the device instructions.') }}</span>
        </div>
        
        <div class="qr-code">
            <img :src="qrURL" alt="">
        </div>

        <p class="fz19 html-text">
            <span dir="rtl" v-html="htmlTextNewLine" v-if="!simIsPorted"></span>
            <span dir="rtl" v-html="htmlTextPorting" v-if="simIsPorted"></span>
        </p>

        <button type="button" class="btn btn--arrows" @click="setStep(simIsPorted ? DEFINED_STEPS['success-esim'] : DEFINED_STEPS['success-esim-new'])">{{ __('After scanning, click here to continue.') }}</button>
    </div>
</template>